import type { UserPreferencesNotificationsHeaderProps } from "./user-preferences-notifications-header.type";

import { ReloadOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";
import { useTranslation } from "react-i18next";

import { UserPreferencesNotificationsDropdown } from "../user-preferences-notifications-dropdown";

import { useUserPreferencesNotificationsHeader } from "./user-preferences-notifications-header.hook";

export const UserPreferencesNotificationsHeader = (
  props: UserPreferencesNotificationsHeaderProps
) => {
  const { t } = useTranslation();
  const { menuItems, onReloadClick, onMenuItemClick } =
    useUserPreferencesNotificationsHeader(props);

  return (
    <Space.Compact>
      <Button icon={<ReloadOutlined />} onClick={onReloadClick}>
        {t("user:preferences.notifications.actions.resetAll")}
      </Button>
      <UserPreferencesNotificationsDropdown
        menuItems={menuItems}
        onMenuItemClick={onMenuItemClick}
      />
    </Space.Compact>
  );
};
